import React from 'react';
import { Box, TextField } from '@mui/material';
import styles from './ChatInput.module.scss';

interface ChatInputProps {
  inputRef: React.RefObject<HTMLInputElement>;
  handleKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  disabled: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ inputRef, handleKeyDown, disabled }) => {
  const handleInputKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleKeyDown(event);
    }
  };

  return (
    <Box
      className={styles.inputContainer}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <TextField
        fullWidth
        multiline
        maxRows={4}
        variant="outlined"
        inputRef={inputRef}
        placeholder="Type a message and press Enter or Return to send..."
        onKeyDown={handleInputKeyDown}
        disabled={disabled}
        data-testid="genai-chat-input"
        className={styles.inputField}
      />
    </Box>
  );
};

export default ChatInput;
